export default import.meta.ROLLDOWN_FILE_URL_TX5a1iViCylaCWPFSCQG2w